export default __webpack_public_path__ + "static/media/hands.ad1e6a9c.jpg";